import { CartProvider, ThemeProvider } from '@boost-sd/app';
import { createRoot } from 'react-dom/client';

export const initCart = () => {
  const cartContainerId = 'boost-sd__cart-container';
  const cartContainer = document.createElement('div');
  cartContainer.setAttribute('id', cartContainerId);
  document.body.appendChild(cartContainer);

  const root = createRoot(cartContainer);

  const updateCartIconHeader = (cartItemCount: number) => {
    const cartCountEl = document.querySelector('.site-header-cart--count');

    if (!cartCountEl) return;

    cartCountEl.className = `site-header-cart--count ${cartItemCount > 0 ? 'visible' : ''}`;
    cartCountEl.setAttribute('data-header-cart-count', `${cartItemCount || ''}`);
  };

  root.render(
    <ThemeProvider>
      <CartProvider
        cartIconHeaderSelector='.site-header-cart--button'
        onUpdateCart={updateCartIconHeader}
      />
    </ThemeProvider>
  );
};
